import { App, ComponentPublicInstance } from "vue"
import router from "@/router"
import pinia from "@/store"
import { reportException } from "@/api/commonApis"

const ErrorHandler = {
  install(app: App) {
    if (process.env.NODE_ENV !== "development") {
      app.config.errorHandler = async (err: unknown, _instance: ComponentPublicInstance | null, _info: string) => {
        if (err instanceof Error) {
          await reportException({
            msg: JSON.stringify({
              System: "admin",
              Page: router.currentRoute.value.path,
              Type: err.name,
              Message: err.message,
              Cause: err.cause,
              Stack: err.stack,
              UserInfo: pinia.state.value.user.userInfo
            })
          })
        }
      }
    }
  }
}

export default ErrorHandler
